import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import api from '../api';

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (password !== confirm) return setError('Passwords do not match.');
        if (password.length < 8) return setError('Password must be at least 8 characters.');
        setLoading(true);
        try {
            await api.post('/auth/reset-password', { token, password });
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to reset password. The link may have expired.');
        }
        setLoading(false);
    };

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        borderRadius: '12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        background: 'rgba(255, 255, 255, 0.05)',
        color: '#ffffff',
        fontSize: '0.95rem',
        boxSizing: 'border-box',
        outline: 'none',
    };

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
            color: '#ffffff', padding: '20px', position: 'relative', overflow: 'hidden',
        }}>
            <div style={{
                position: 'fixed', top: '-20%', right: '-10%', width: '500px', height: '500px',
                background: 'radial-gradient(circle, rgba(255, 193, 7, 0.12) 0%, transparent 70%)',
                borderRadius: '50%', pointerEvents: 'none', zIndex: 0,
            }} />

            <div style={{ marginBottom: '32px', position: 'relative', zIndex: 10 }}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <Logo size="large" dark={false} />
                </Link>
            </div>

            <div style={{
                width: '100%', maxWidth: '420px', padding: '40px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '24px', backdropFilter: 'blur(20px)',
                position: 'relative', zIndex: 10, boxSizing: 'border-box',
            }}>
                {!token ? (
                    <>
                        <h2 style={{ margin: '0 0 12px', textAlign: 'center', fontSize: '1.5rem', fontWeight: 700 }}>
                            Invalid Link
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.6)', textAlign: 'center', margin: '0 0 24px' }}>
                            This reset link is missing or invalid.
                        </p>
                        <p style={{ textAlign: 'center', margin: 0 }}>
                            <Link to="/forgot-password" style={{ color: '#ffc107', fontWeight: 600, textDecoration: 'none' }}>
                                Request a new link
                            </Link>
                        </p>
                    </>
                ) : success ? (
                    <>
                        <div style={{ textAlign: 'center', marginBottom: '16px', fontSize: '2.5rem' }}>✅</div>
                        <h2 style={{ margin: '0 0 12px', textAlign: 'center', fontSize: '1.5rem', fontWeight: 700 }}>
                            Password Updated
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.6)', textAlign: 'center', margin: '0 0 24px', lineHeight: 1.6 }}>
                            Your password has been reset. Redirecting you to sign in…
                        </p>
                        <p style={{ textAlign: 'center', margin: 0 }}>
                            <Link to="/login" style={{ color: '#ffc107', fontWeight: 600, textDecoration: 'none' }}>
                                Sign in now
                            </Link>
                        </p>
                    </>
                ) : (
                    <>
                        <h2 style={{ margin: '0 0 8px', textAlign: 'center', fontSize: '1.75rem', fontWeight: 700 }}>
                            Set New Password
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.6)', textAlign: 'center', margin: '0 0 28px', fontSize: '0.95rem' }}>
                            Choose a new password for your account.
                        </p>

                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div>
                                <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)' }}>
                                    New password
                                </label>
                                <input
                                    type="password"
                                    required
                                    autoComplete="new-password"
                                    placeholder="At least 8 characters"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    style={inputStyle}
                                />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)' }}>
                                    Confirm password
                                </label>
                                <input
                                    type="password"
                                    required
                                    autoComplete="new-password"
                                    placeholder="••••••••"
                                    value={confirm}
                                    onChange={e => setConfirm(e.target.value)}
                                    style={inputStyle}
                                />
                            </div>

                            {error && (
                                <p style={{ margin: 0, color: '#ef4444', fontSize: '0.88rem', fontWeight: 500 }}>
                                    {error}
                                </p>
                            )}

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    padding: '14px',
                                    background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                                    color: '#000', border: 'none', borderRadius: '12px',
                                    fontWeight: 700, fontSize: '1rem',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    opacity: loading ? 0.7 : 1,
                                    boxShadow: '0 4px 20px rgba(255,193,7,0.3)',
                                }}
                            >
                                {loading ? 'Saving…' : 'Set New Password'}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}

export default ResetPassword;
